// * 组件加载器
// * TODO 落地其他产物前，需迁移至 webx jssdk 中
// * 详见 https://cooper.didichuxing.com/knowledge/share/page/s44dpYmvaw6h 4.4.3 节
import { loadScript } from '../platform/loader';
import { utils } from '@didi/webx-js';
const walkNode = (node, cb) => {
    const { children } = node;
    cb(node);
    if (!children || !children.length)
        return;
    // todo：改为for 可以控制停止
    children.forEach(item => {
        walkNode(item, cb);
    });
};
let widgetResourceDict = {}; // 全部组件资源 cdn 字典
let widgetResourceKeyList = []; // 活动内容中需要加载的组件资源的组件 key 列表
// module
const widgetModules = {};
// 加载 js
const fetchWidgetJs = (url, key) => new Promise(resolve => {
    loadScript(url, {
        crossOrigin: true // 目前组件版本管理使用此方法加载组件，如果不加crossOrigin标识，若组件内部上报出错误都是ScriptError. 
    }, error => {
        if (!error) {
            resolve();
        }
        else {
            // @ts-ignore
            window?.Omega?.trackError('webx-js error', 5001, '组件静态资源加载失败', {
                packageName: key,
                cdn: url,
                package: 'web',
            });
        }
    });
});
const _loadSingle = async (resource) => {
    if (!resource)
        return Promise.reject('未传入参数');
    const { key, cdn } = resource;
    if (!key) {
        return Promise.reject(`未传入组件 key ${resource}`);
    }
    if (!cdn || utils.isEmptyObject(cdn)) {
        return Promise.reject(`未传入组件静态资源数据 cdn  ${resource}`);
    }
    // TODO 优化：cdn 内部数据结构合法性校验
    if (key in widgetModules) {
        const jsModule = widgetModules[key];
        console.log(`组件 ${key} 无需重复加载`, jsModule);
        return Promise.resolve(jsModule);
    }
    // TODO 优化：配合组件打包修改，window → var
    await Promise.all([fetchWidgetJs(cdn.js, key)]);
    return new Promise((resolve, reject) => {
        const jsModule = window[key];
        if (jsModule) {
            widgetModules[key] = jsModule;
            // console.log(`=== 组件 ${key} 加载完成 ===`, jsModule)
            resolve(jsModule);
        }
        else {
            console.warn(`=== window[${[key]}] 不存在 ===`);
            reject(`window[${[key]}] 不存在`);
        }
    });
};
/**
 * 加载单个组件资源或组件资源列表
 * @param {object Object | object Array} widgetRes 单个组件资源对象、或列表，每一项形如{ key: '', cdn: { js: '', css: '' } }
 * @returns {Promise<Object | Array>} 加载结果，每一项形如 { error: '', module }
 */
const loadWidget = async (widgetRes) => {
    if (!widgetRes) {
        console.warn('loadWidget 未传入有效参数');
        return;
    }
    const isArray = Array.isArray(widgetRes);
    const list = isArray ? widgetRes : [widgetRes];
    const plist = list.map((item) => _loadSingle(item));
    const resList = await Promise.allSettled(plist);
    const result = resList.map((res) => {
        return {
            error: res.reason || null,
            module: res.value,
        };
    });
    return isArray ? result : result[0];
};
/**
 * 更新组件资源数据
 * 生成 widgetResourceDict 与 widgetResourceKeyList，过滤掉活动内容中没用到组件，
 * @param {Object|null} xpubData xpub project data（包含组件资源列表），不包含scenes字段不进行过滤操作 { sceneId: 0, scenes: {}, resourceList: [{ id: 0, widgetKey: '', dist: { js: '', css: '' } }]... }
 * @returns {Object} { list, dist } 处理完毕的组件资源。列表、字典的每一项与 loadWidget() 入参一致，列表顺序与 xpubData 中图层顺序、或 resourceList 一致
 */
const updateWidgetResource = (xpubData) => {
    const dict = {}; // resourceItem dict
    const list = []; // resourceItem list
    const resourceList = xpubData.widgetList || [];
    if (resourceList.length === 0)
        return;
    resourceList.forEach(item => {
        // 已更新过的，过滤
        if (item.widgetKey in widgetResourceDict)
            return;
        // 兼容接口直接获取到的数据，eg: dist = { client: {}, server: {} }
        let cdn = item.dist?.client ? item.dist?.client : item.dist;
        const resourceItem = {
            ...item,
            // loadWidget() 标准入参结构
            key: item.widgetKey,
            cdn,
        };
        dict[item.widgetKey] = resourceItem;
        !xpubData.scenes && list.push(resourceItem);
    });
    // 传入 Xpub 活动内容时，按照图层顺序生成过滤后的列表
    if (xpubData?.scenes) {
        const layerTypeSet = new Set(); // 用来判断去重
        const updateFilteredList = layer => {
            const resource = dict[layer.type];
            if (!layerTypeSet.has(layer.type) && resource) {
                list.push(resource);
                layerTypeSet.add(layer.type);
            }
        };
        xpubData?.scenes?.layers?.forEach(layer => {
            walkNode(layer || {}, updateFilteredList);
        });
        xpubData?.scenes?.multiPages?.forEach(page => {
            page.layers.forEach(layer => {
                walkNode(layer || {}, updateFilteredList);
            });
        });
    }
    // 更新
    widgetResourceDict = Object.assign(widgetResourceDict, dict);
    widgetResourceKeyList = widgetResourceKeyList.concat(list.map(resource => resource.key));
    const result = {
        list,
        dict,
    };
    console.log('=== 组件资源数据 widgetResourceDict ===', widgetResourceDict);
    return result;
};
export { loadWidget, updateWidgetResource, widgetResourceDict, widgetResourceKeyList, widgetModules, };
